/* eslint-disable prettier/prettier */
export const ProductUserType = ['MANUFACTURER_IMPORTER', 'OTHER'] as const;

export type ProductUserType = typeof ProductUserType[number];
